import React from 'react';
import moment from 'moment';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { offer } from '../../../services/api';

import Frame from '../../Wrappers/Frame';
import { Field } from 'react-final-form';
import { testWindow } from '../../Wrappers/MainWindow';
import { DateAdapter, InlineDateAdapter } from '../Create/DateAdapter';
import { FormLabelBox, FormLabel } from '../../Common';
import { CallTimeTypesAdapter, FieldWithError, RepeatGroupAdapter } from '../Create/FormAdapters';
import SaveButton from '../Create/SaveButton';
import OfferCallAddress from './OfferCallAddress';
import '../Offer.css';

interface Props {
  id: string;
  match: any;

  redirectToSuccessPage: Function;
}

interface State {
  offer: Offer | null;
  attendees: Array<Attendee>;
  updates: Object;
  isSubmitting: Boolean;
  isDisabled: Boolean;
}

class AddCallSheet extends React.Component<Props, State> {
  state: State = {
    offer: null,
    attendees: [],
    updates: {},
    isSubmitting: false,
    isDisabled: true,
  };

  componentDidMount() {
    offer.getById(this.props.match.params.id).then((data: any) => {
      this.setState({
        offer: data.data,
        isDisabled: data.data.attendees[0].call_sheet_status === 'ready',
      });

      this.setState({ attendees: data.data.attendees.filter((a) => a.status !== 'canceled') });
    });
  }

  render() {
    if (this.state.offer === null) {
      return <></>;
    }

    return (
      <div className="row">
        <div className="col">
          <Frame
            title={`${this.state.offer?.subtitle} Add Call Sheet Info`}
            children={
              <Form
                onSubmit={(values) => {}}
                mutators={{
                  setLocationnAttribute: ([fieldName, fieldVal], state, { changeValue }) => {
                    changeValue(state, fieldName, () => fieldVal);
                  },
                }}
                initialValues={Object.assign(this.state.offer, { job_start_date_type: 'all' })}
                render={({ handleSubmit, invalid, values, form }) => (
                  <div className="row">
                    <div className="col">
                      <>
                        <FormLabelBox>
                          <FormLabel>JOB DETAILS / REQUIREMENTS</FormLabel>
                        </FormLabelBox>

                        <FieldWithError
                          name="job_requirements"
                          component="textarea"
                          rows="4"
                          style={{ color: 'var(--color-greyish-brown)' }}
                          placeholder="List anything the model needs to know prior to arrival at the job. (e.g. dress code, special directions, etc.)"
                          disabled={this.state.isDisabled}
                        />
                      </>

                      <Field
                        name="location"
                        disabled={this.state.isDisabled}
                        render={(props) => (
                          <OfferCallAddress
                            onChanged={(value) => {
                              form.mutators.setLocationnAttribute('location', value, form.getState);
                            }}
                            {...props}
                          />
                        )}
                      />
                    </div>

                    <div className="col">
                      <>
                        <FormLabelBox>
                          <FormLabel>CALL TIME</FormLabel>
                          <div className="row" style={{ paddingLeft: '15px', paddingTop: '30px' }}>
                            <CallTimeTypesAdapter disabled={this.state.isDisabled} />
                          </div>
                        </FormLabelBox>
                      </>

                      {values !== null && values.job_start_date_type === 'individual' ? null : (
                        <>
                          <FormLabelBox>
                            <FormLabel>CALL DATE/TIME</FormLabel>
                          </FormLabelBox>

                          <FieldWithError
                            name="job_start_date"
                            disabled={this.state.isDisabled}
                            component={DateAdapter}
                          />
                        </>
                      )}

                      <>
                        <FormLabelBox>
                          <FormLabel>DURATION</FormLabel>
                          <FormLabel style={{ color: '#b4a361' }}>
                            (APPROXIMATE LENGTH OF JOB IN HRS)
                          </FormLabel>
                        </FormLabelBox>

                        <FieldWithError
                          name="job_end_date_duration"
                          type="number"
                          min="1"
                          max="8766"
                          component="input"
                          disabled={this.state.isDisabled}
                        />
                      </>

                      {values !== null && values.job_start_date_type === 'individual' ? (
                        <>
                          <table
                            className="call-time-table"
                            style={{ color: 'var(--color-greyish-brown)' }}
                          >
                            <thead>
                              <tr>
                                <th>MODEL</th>
                                <th>CALL TIME</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.attendees.map((item) => (
                                <tr key={item.id}>
                                  <td>{item.model.name}</td>
                                  <td>
                                    <FieldWithError
                                      name={'call_time[' + item.id + ']'}
                                      value={item.call_time}
                                      disabled={this.state.isDisabled}
                                      onChanged={(value) => {
                                        const callTime = moment(value).format('M/D/YYYY h:mm A');

                                        if (callTime !== item.call_time) {
                                          let updates = this.state.updates;
                                          updates[item.id] = callTime;

                                          this.setState({ updates });
                                        }
                                      }}
                                      component={InlineDateAdapter}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      ) : null}
                      <>
                        {this.state.isSubmitting === true && (
                          <span
                            style={{
                              width: '200px',
                              height: '40px',
                              textAlign: 'center',
                              display: 'block',
                              marginTop: '25px',
                            }}
                          >
                            <img src="/img/ajax-loader.gif" alt="Loading" />
                          </span>
                        )}
                        {this.state.isSubmitting === false && (
                          <SaveButton
                            ready={!this.state.isDisabled}
                            last={true}
                            title="SAVE CALL SHEET"
                            click={() => {
                              this.setState({ isSubmitting: true });

                              this.state.offer &&
                                offer
                                  .setCallSheetInformation(
                                    this.state.offer.id,
                                    {
                                      location: values.location,
                                      job_requirements: values.job_requirements,
                                      job_end_date_duration: values.job_end_date_duration,
                                      job_start_date_type: values.job_start_date_type,
                                      job_start_date: values.job_start_date,
                                    },
                                    this.state.updates
                                  )
                                  .then(() => {
                                    this.setState({ isSubmitting: false, updates: {} });

                                    this.props.redirectToSuccessPage(this.state.offer?.id);
                                  })
                                  .catch((reason) => {
                                    console.error(reason);

                                    this.setState({ isSubmitting: false });
                                  });
                            }}
                          />
                        )}
                      </>
                    </div>
                  </div>
                )}
              />
            }
          />
        </div>
      </div>
    );
  }
}

export default connect(null, {
  redirectToSuccessPage: (offerId: string) => push('/offers/' + offerId + '/callSheet/submitted'),
})(testWindow(AddCallSheet, 'offers'));
